import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap text-sm font-medium transition-colors duration-200 ${
      isActive ? "text-accent-500" : "text-background-100 hover:text-accent-300"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-900/95 backdrop-blur-sm border-b border-primary-700/60">
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base md:text-lg font-bold text-background-50">邻居的妻子</span>
            <span className="text-[10px] tracking-widest text-background-300/80">影视大全</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/search"
            className="w-9 h-9 flex items-center justify-center rounded-md border border-primary-600 text-background-100 hover:text-accent-400 hover:border-accent-400 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <Link
            to="/category"
            className="whitespace-nowrap px-4 py-2 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer"
          >
            开始找剧
          </Link>
        </div>

        <button
          type="button"
          className="md:hidden w-10 h-10 flex items-center justify-center text-background-50 cursor-pointer"
          onClick={() => setOpen((v) => !v)}
          aria-label="菜单"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-primary-700/60 bg-primary-900 px-4 pb-4 pt-2 animate-fade-in">
          <nav className="flex flex-col">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 border-b border-primary-800/70 text-sm font-medium transition-colors ${
                    isActive ? "text-accent-500" : "text-background-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/category"
            onClick={() => setOpen(false)}
            className="mt-4 block text-center whitespace-nowrap px-4 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold cursor-pointer"
          >
            开始找剧
          </Link>
        </div>
      )}
    </header>
  );
}